
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { store } from "../../storeLogistica";
import VueSelect from "vue-select";
import _ from "lodash";

export default {
  name: "app-mdfe-form-viagemTab",
  components: {
    VueSelect,
  },
  directives: {
  },
  data() {
    return {
      store,
      form: {
        uf_carregamento: null,
        uf_descarga: null,
        cidade_carregamento: null,
        cep_carregamento: null,
        cep_descarga: null,
        percurso: [],
      },
      ufError: false,
      ufErrorDescarga: false,
      cidadeError: false,
      ufs: [],
      ufsSearched1: [],
      ufsSearched2: [],
      ufsSearched3: [],
      cidades: [],
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
  ],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      const [{ data: ufsData }] = await Promise.all([
        this.$http.post('/sistema/get-uf'),
      ])
      this.ufs = ufsData;
      this.ufsSearched1 = this.ufs;
      this.ufsSearched2 = this.ufs;
      this.ufsSearched3 = this.ufs;
      const mdfeData = this.$route.params?.mdfeData?.mdfe;
      if (mdfeData) {
        this.form.uf_carregamento = ufsData.find(uf => uf.sigla === mdfeData.uf_carregamento);
        this.form.uf_descarga = ufsData.find(uf => uf.sigla === mdfeData.uf_descarga);
        this.form.cep_carregamento = mdfeData.cep_carregamento;
        this.form.cep_descarga = mdfeData.cep_descarga;
        const { data } = await this.$http.post('/sistema/get-cidade-by-uf',
          { uf: this.form.uf_carregamento.sigla, cidade: mdfeData.cidade_carregamento.cidade }
        );
        this.form.cidade_carregamento = data[0];
        this.form.percurso = mdfeData.ufsPercurso ? ufsData.filter(uf => mdfeData.ufsPercurso.includes(uf.sigla)) : []
        this.ufsSearched3 = this.ufs
          .filter(uf => {
            const onlyUfsSelected = this.form?.percurso ? this.form.percurso.map(item => item.sigla) : []
            return !onlyUfsSelected.includes(uf.sigla)
          })
      }
    },
    searchUf(search, ufNumber) {
      if (ufNumber === 3) {
        this[`ufsSearched${ufNumber}`] = this.ufs
          .filter(uf => uf.sigla.toLowerCase().includes(search.toLowerCase()))
          .filter(uf => {
            const onlyUfsSelected = this.form?.percurso ? this.form.percurso.map(item => item.sigla) : []
            return !onlyUfsSelected.includes(uf.sigla)
          })
      } else {
        this[`ufsSearched${ufNumber}`] = this.ufs.filter(uf => uf.sigla.toLowerCase().includes(search.toLowerCase()))
      }
    },
    handleSelectPercurso(value) {
      this.ufsSearched3 = this.ufs.filter(uf => {
        const onlyUfsSelected = value.map(item => item.sigla)
        return !onlyUfsSelected.includes(uf.sigla)
      })
    },
    onSearchCidades(search, loading) {
      if (!this.form.uf_carregamento) {
        this.$toast.error('Informe primeiro o UF');
        return;
      }
      if (search.length) {
        loading(true);
        this.searchCidades(loading, search, this);
      }
    },
    searchCidades: _.debounce(async (loading, cidade, vm) => {
      const { data } = await vm.$http.post('/sistema/get-cidade-by-uf', { uf: vm.form.uf_carregamento.sigla, cidade });
      vm.cidades = data
      if (loading) loading(false);
    }, 350),
    validateState(field) {
      return !!this.form[field];
    }
  },
  created() {
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 3
    }
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 4 && oldValue < newValue) {
        if (!this.form.uf_carregamento) {
          this.$toast.error('UF de carregamento obrigatória!')
          this.ufError = true;
          this.store.currentTab = oldValue;
        }
        if (!this.form.cidade_carregamento) {
          this.$toast.error('Cidade de carregamento obrigatória!')
          this.cidadeError = true;
          this.store.currentTab = oldValue;
        }
        if (!this.form.uf_descarga) {
          this.$toast.error('UF de carregamento obrigatória!')
          this.ufErrorDescarga = true;
          this.store.currentTab = oldValue;
        }
        if (!this.form.cep_carregamento) {
          this.$toast.error('CEP de carregamento obrigatório!')
          this.store.currentTab = oldValue;
        }
        if (!this.form.cep_descarga) {
          this.$toast.error('CEP de descarga obrigatório!')
          this.store.currentTab = oldValue;
        }
        this.store.formData = {
          ...this.store.formData,
          cidade_carregamento: {
            cidade: this.form.cidade_carregamento.cidade,
            id_cidade: this.form.cidade_carregamento.id_cidade
          },
          uf_carregamento: this.form.uf_carregamento.sigla,
          uf_descarga: this.form.uf_descarga.sigla,
          cep_carregamento: this.form.cep_carregamento,
          cep_descarga: this.form.cep_descarga,
          ufsPercurso: this.form.percurso.map(uf => uf.sigla),
        }
      }
    },
  }
}

